import { useEffect, useRef, useState } from "react";

const useSectionDimensions = () => {
  const imgEleRef = useRef<HTMLImageElement>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const syncDimensions = () => {
    if (imgEleRef.current) {
      setWidth(imgEleRef.current.clientWidth);
      setHeight(imgEleRef.current.clientHeight);
    }
  }

  useEffect(() => {
    window.addEventListener("resize", syncDimensions);

    syncDimensions();
    return () => {
      window.removeEventListener("resize", syncDimensions);
    }
  }, []);

  return {
    imgEleRef,
    width,
    height,
    syncDimensions,
  }
}

export default useSectionDimensions;